import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=95e79966&"
import script from "./Checkout.vue?vue&type=script&lang=js&"
export * from "./Checkout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/orca/workspaces/DIA-3dprima_v2/task-50584/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95e79966')) {
      api.createRecord('95e79966', component.options)
    } else {
      api.reload('95e79966', component.options)
    }
    module.hot.accept("./Checkout.vue?vue&type=template&id=95e79966&", function () {
      api.rerender('95e79966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/checkout/Checkout.vue"
export default component.exports